import Index from '@/modules/Marketing/index.vue'
import List from '@/modules/Marketing/components/List.vue'
import LocationProfile from '@/modules/Bonventa/components/Profile.vue'

export default [{
  path: '/marketing',
  name: 'marketing',
  component: Index,
  title: 'Marketing',
  children: [{
    path: 'group',
    name: 'group-location-list',
    component: List,
  },
  {
    path: 'messages',
    name: 'group-location-profile',
    component: LocationProfile,
  },
  ],
}]
